export const initAmazonsdk = () => {
  return new Promise(resolve => {
    window.onAmazonLoginReady =
        function() {
          amazon.Login.setClientId(`${process.env.VUE_APP_AMAZON_CLIENT_KEY}`);
        };
    (function(d) {
      var a = d.createElement('script'); a.type = 'text/javascript';
      a.async = true; a.id = 'amazon-login-sdk';
      a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
      d.getElementById('amazon-root').appendChild(a);
    })(document);
  })
}
